<template>
  <div
    v-if="toggle.userExamDocument && !toggle.covax"
    class="document-box"
  >
    <div
      class="box box-title"
      :class="'background-' + titleBackgroundColor"
    >
      {{ title }}
    </div>
    <div :class="[{ 'box-separated': buttonData.boxSeparated }]" />

    <div
      v-if="!isUploadButton"
      class="box box-description"
      :class="'background-' + subtitleBackgroundColor + '-button'"
      @click="callAction(buttonData.action)"
    >
      {{ subtitle }}
    </div>

    <div
      v-else
      class="box-label"
    >
      <label
        v-if="uploadStatus !== 'STATUS_UPLOADING'"
        ref="uploadDocTrigger"
        :for="'fileToUpload-' + fileInfo.id_document_template_exam"
        class="box box-description"
        :class="'background-' + subtitleBackgroundColor + '-button'"
      >
        <md-tooltip
          md-direction="top"
          md-delay="400"
          class="tooltip-small"
        >
          Atenção!
          <br>Disponível upload de um arquivo. Caso tenha vários, solicitamos <br>que envie todos em um arquivo
          único de no máximo 50 MB.
        </md-tooltip>
        {{ subtitle }}
      </label>

      <div
        v-else
        class="box box-loading"
      >
        <div class="skeleton" />
      </div>

      <form :id="'fileParent-' + fileInfo.id_document_template_exam">
        <input
          :id="'fileToUpload-' + fileInfo.id_document_template_exam"
          type="file"
          class="hide-input"
          :name="'fileToUpload-' + fileInfo.id_document_template_exam"
          accept=".png, .jpeg, .jpg, .pdf"
          @change="onFileChange"
        >
      </form>
    </div>
  </div>
</template>

<script>
import documentLaboratoryService from '@/api/documentLaboratory'
import notify from '@/api/notification'
import { eventBus, DOCUMENT_FINISH_UPLOAD } from '@/api/eventbus'
import uploadFileUtils from '@/utils/file-upload-utils'
import { mapActions, mapGetters } from 'vuex'
import Moment from 'moment'

const STATUS_INITIAL = 'STATUS_INITIAL'
const STATUS_UPLOADING = 'STATUS_UPLOADING'
const STATUS_FINISHED = 'STATUS_FINISHED'

const STATE_PENDING = 'STATE_PENDING'
const STATE_UPLOADED = 'STATE_UPLOADED'

export default {
  name: 'DocumentBox',
  props: {
    osNumber: Number,
    buttonData: Object,
    fileInfo: Object,
    examInfo: Object,
    docIndex: Number
  },
  data: () => {
    return {
      uploadStatus: STATUS_INITIAL,
      state: STATE_PENDING,
      states: {
        STATE_UPLOADED: {
          title: '3',
          subtitle: 'Documento Anexado',
          firstColor: 'green',
          secondColor: 'green'
        },
        STATE_PENDING: {
          title: '3',
          subtitle: 'Anexar o documento digitalizado',
          firstColor: 'orange',
          secondColor: 'orange'
        }
      }
    }
  },
  computed: {
    ...mapGetters(['profile', 'isDocumentUploadModalVisible', 'toggle']),
    titleBackgroundColor: function () {
      if (this.buttonData.title === '3') {
        return this.states[this.state].firstColor
      } else {
        return this.buttonData.titleBackgroundColor
      }
    },
    subtitleBackgroundColor: function () {
      if (this.buttonData.title === '3') {
        return this.states[this.state].secondColor
      } else {
        return this.buttonData.subtitleBackgroundColor
      }
    },
    title: function () {
      if (this.buttonData.title === '3') {
        return this.states[this.state].title
      } else {
        return this.buttonData.title
      }
    },
    subtitle: function () {
      if (this.buttonData.title === '3') {
        return this.states[this.state].subtitle
      } else {
        return this.buttonData.subtitle
      }
    },
    isUploadButton: function () {
      return this.buttonData.title === '3' && this.state === 'STATE_PENDING'
    }
  },
  watch: {
    isDocumentUploadModalVisible: function (newVal) {
      if (!newVal) {
        this.reset()
        eventBus.$emit(DOCUMENT_FINISH_UPLOAD)
      }
    }
  },
  mounted() {
    this.state = this.getInitialState()
  },
  methods: {
    ...mapActions(['clearAllOrderData', 'clearAllSampleData']),
    callAction(val) {
      if (val === 'download') {
        this.downloadFileTemplate()
        this.submitAnalyticsEvent('Download de template')
      } else if (val === 'upload' && this.isUploadButton) {
        this.uploadDocumentFile()
        this.submitAnalyticsEvent('Upload de documento')
      }
    },
    downloadFileTemplate() {
      this.$emit('download-document', this.fileInfo)
    },
    openUrl(url) {
      window.open(url, '_blank')
    },
    uploadDocumentFile(file) {
      let analyticsStartTime = Moment(new Date())
      this.uploadStatus = STATUS_UPLOADING
      documentLaboratoryService

        .uploadDocumentExam({
          osNumber: this.examInfo.osNumber,
          idDocumentTemplateExam: this.fileInfo.id_document_template_exam,
          idExamOrder: this.examInfo.id,
          fileName: this.fileInfo.fileName,
          file: file
        })
        .then(response => {
          this.uploadStatus = STATUS_FINISHED
          notify({
            title: 'AVISO:',
            message: 'Documento anexado com sucesso!'
          })
          eventBus.$emit('uploadCompleted', {
            exam: this.examInfo,
            docIndex: this.docIndex,
            fileInfoUpdated: response.data
          })
          this.$emit('uploadFinished', {
            osNumber: this.number_alvaro_order,
            docIndex: this.docIndex,
            fileInfoUpdated: response.data
          })
          this.state = STATE_UPLOADED
          this.analyticsForUploadTime({ startTime: analyticsStartTime, fileSize: file.size, response: 'Sucesso' })
        })
        .catch(error => {
          this.uploadStatus = STATUS_FINISHED
          notify({
            title: 'Arquivo não anexado!',
            message: error.response.data.message
          })
          this.analyticsForUploadTime({ startTime: analyticsStartTime, fileSize: file.size, response: 'Falha' })
        })
    },
    onFileChange(e) {
      const file = e.target.files[0] || e.dataTransfer.files[0]

      if (file && uploadFileUtils.validateFileType(file)) {
        this.uploadDocumentFile(file)
        let parent = document.getElementById('fileParent-' + this.fileInfo.id_document_template_exam)
        parent.reset()
      }
    },
    reset() {
      this.uploadStatus = STATUS_INITIAL
    },
    getInitialState() {
      return this.fileInfo.documentExamUpload === null || this.fileInfo.documentExamUpload.length === 0
        ? STATE_PENDING
        : STATE_UPLOADED
    },
    submitAnalyticsEvent(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Upload de Documentos Pendentes',
        action: action,
        osNumber: this.number_alvaro_order,
        label: this.examInfo.id
      })
    },
    analyticsForUploadTime({ startTime, fileSize, response }) {
      let endTime = Moment(new Date())
      let uploadTime = endTime.diff(startTime, 'seconds')

      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Upload de Documentos Pendentes',
        action: 'Tempo de Upload - ' + response,
        label: uploadTime,
        value: uploadTime,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName,
        'file-size': fileSize
      })
    },
    triggerClick() {
      const label = this.$refs.uploadDocTrigger
      if (label) {
        label.click()
      }
    }
  }
}
</script>

<style lang="scss">
  @import '../../../../../static/stylesheets/variables';

  .document-box {
    display: flex;
    flex-direction: row;
    margin: 7px;
    max-width: 31.5%;
    width: 70%;

    .box {
      padding: 10px;
      height: 100%;
      text-transform: uppercase;
      text-align: center;
      color: #fff;
      font-weight: 500;

      &-title {
        border-radius: 3px 0 0 3px;
        font-size: 20px;
        line-height: 26px;
        width: 48px;
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: bold;
      }

      &-description {
        font-size: 12px;
        line-height: 14px;
        border-radius: 0 3px 3px 0;
        flex: 10 10 auto;
        text-align: left;
        align-items: center;
        display: flex;
        font-weight: 500;
        font-family: Roboto, sans-serif;
      }

      &-loading {
        border-radius: 6px;
        background-color: #ffffff;
        animation: loading 1.5s infinite;
        background-position: -400px;
        background-size: 100% 100%;
        background-image: linear-gradient(
          90deg,
          hsla(0, 20%, 97.1%, 0.4),
          hsla(0, 2.1%, 62.7%, 0.2) 50%,
          hsl(0, 0%, 100%)
        );
        background-repeat: no-repeat;

        .skeleton {
          height: 19px;
          opacity: 0.1;
          border-radius: 3px;
          background-color: #111;
        }

        @keyframes loading {
          to {
            background-position: 400px;
          }
        }
      }

      &-label {
        width: 80%;
      }
    }

    .background {
      &-green {
        background-color: $ocean-green;
        color: white;

        &-button {
          background-color: $ocean-green;
          color: white;
          cursor: not-allowed;
        }
      }
      &-orange {
        background-color: $buttercup;
        color: white;

        &-button {
          background-color: $buttercup;
          color: white;
          cursor: pointer;

          &:hover,
          &:active,
          &:focus {
            background: #bb7808;
          }
        }
      }
      &-white {
        background-color: white;
        color: #979797;

        &-button {
          background-color: white;
          color: #979797;
        }
      }
    }

    .box-separated {
      margin-left: 2px;
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
      opacity: 0;
    }
  }
</style>
